<template>
  <section class="ec-section partners">
    <div class="ec-container">
      <p class="partners__label" v-reveal>{{ $t('partners.label') }}</p>
      <div class="partners__grid" v-reveal="80">
        <div v-for="p in partners" :key="p" class="partners__item">{{ p }}</div>
      </div>

      <div class="partners__quote" v-reveal="120">
        <span class="partners__mark">“</span>
        <blockquote>{{ $t('partners.quote') }}</blockquote>
        <div class="partners__author">
          <span class="avatar">{{ $t('partners.authorAvatar') }}</span>
          <div><strong>{{ $t('partners.authorName') }}</strong><em>{{ $t('partners.authorRole') }}</em></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnersSection',
  data() {
    return {
      partners: ['GameVerse', 'FinPay', 'CloudRetail', 'EduLink', 'IoTCore', 'LogiChain', 'DataStream', 'TechNova', 'SocialHub', 'PayGlobal', 'BrightAI', 'NextGaming']
    }
  }
}
</script>

<style scoped>
.partners { padding-top: 0; }
.partners__label { text-align: center; color: var(--ec-text-mute); font-size: 15px; margin-bottom: 34px; }
.partners__grid { display: grid; grid-template-columns: repeat(6, 1fr); gap: 14px; }
.partners__item {
  display: grid; place-items: center; height: 76px;
  background: var(--ec-card); border: 1px solid var(--ec-line); border-radius: 14px;
  color: var(--ec-text-soft); font-weight: 700; font-size: 16px; letter-spacing: .02em;
  transition: all .3s ease; filter: grayscale(1); opacity: .75;
}
.partners__item:hover { filter: none; opacity: 1; transform: translateY(-3px); border-color: rgba(255,153,0,.4); color: var(--ec-text); }

.partners__quote {
  position: relative; margin-top: 70px; max-width: 860px; margin-left: auto; margin-right: auto;
  text-align: center; padding: 50px 40px;
  background: linear-gradient(165deg, rgba(255,153,0,.08), rgba(255,111,0,.05));
  border: 1px solid var(--ec-line); border-radius: 24px;
}
.partners__mark { position: absolute; top: 4px; left: 30px; font-size: 90px; line-height: 1; color: rgba(255,153,0,.35); font-family: Georgia, serif; }
.partners__quote blockquote { margin: 0 0 26px; font-size: clamp(18px, 2.2vw, 23px); line-height: 1.6; font-weight: 500; color: var(--ec-text); }
.partners__author { display: inline-flex; align-items: center; gap: 13px; }
.avatar { width: 46px; height: 46px; border-radius: 50%; display: grid; place-items: center; background: var(--ec-grad); color: #04101f; font-weight: 800; font-size: 18px; }
.partners__author strong { display: block; font-size: 15px; text-align: left; }
.partners__author em { font-style: normal; font-size: 13px; color: var(--ec-text-mute); }

@media (max-width: 760px) { .partners__grid { grid-template-columns: repeat(3, 1fr); } }
</style>
